<template>
    <el-dialog
        @close="closeDialog"
        class="leader-dialog"
        width="500px"
        :title="title"
        :show-close="true"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
    >
        <el-form
            class="leader-style-form"
            ref="unitForm"
            :model="unitForm"
            :rules="rules"
        >
            <el-form-item label="部门名称" prop="target_unit_name">
                <el-input v-model="unitForm.target_unit_name"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
             <el-button
                size="small"
                class="leader-common-button"
                @click="saveUnit"
                >保存</el-button
            >
            <el-button
                size="small"
                class="leader-common-button"
                @click="dialogVisible = false"
                >取消</el-button
            > 
        </span>
    </el-dialog>
</template>
<script>
import * as api from "@/http/target-config.js";
export default {
    data() {
        return {
            unitForm: {
                target_unit_name: ""
            },
            rules: {
                target_unit_name: [
                    {
                        required: true,
                        message: "请输入部门名称",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    props: {
        dialogVisible: {
            type: Boolean
        },
        pUnitId: String,
        treeUnitId: String,
        unit_id: String,
        title: {
            type: String,
            default: "新增部门"
        },
        unitName: String
    },
    watch: {
        dialogVisible(newVal) {
            if (newVal && this.title == "修改部门") {
                this.unitForm.target_unit_name = this.unitName;
            }
        }
    },
    methods: {
        closeDialog() {
            this.dialogVisible = false;
            this.$refs.unitForm.resetFields();
            this.$emit("update:dialogVisible", this.dialogVisible);
            this.$emit("closeCb");
        },
        saveUnit() {
            this.$refs.unitForm.validate(valid => {
                if (valid) {
                    api.saveTargetUnitTree({
                        p_target_unit_id: this.pUnitId,
                        target_unit_id: this.treeUnitId,
                        unit_id: this.unit_id,
                        ...this.unitForm
                    }).then(res => {
                        if (res && res.error_code === "0") {
                            this.$message({
                                message: res.error_msg,
                                type: "success"
                            });
                            this.closeDialog();
                        }
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss">
.access-control-dialog-2 {
}
</style>
